
import Vue from "vue";
import { marked } from "marked";
import { ThisTypedComponentOptionsWithRecordProps } from "vue/types/options";
import Headline from "../components/shared/Headline.vue";
import Breadcrumb from "../components/shared/Breadcrumb.vue";
import BreadcrumbItem from "../components/shared/BreadcrumbItem.vue";
import LoadingSpinner from "../components/LoadingSpinner.vue";
import { IAIImage } from "../@types/interface.d";

interface DataType {
  notFound: boolean;
  content: string;
  generating: boolean;
  image: IAIImage|undefined;
  show: boolean;
}

interface MethodType {
  init: () => void;
}

interface ComputedType {
  converted: string;
}

export default Vue.extend({
  name: "AIImages",
  components: {
    Headline,
    Breadcrumb,
    BreadcrumbItem,
    LoadingSpinner,
  },
  data(): DataType {
    const show = !!this.$route.query.show;
    return {
      notFound: false,
      content: "",
      generating: false,
      image: undefined,
      show,
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      fetch("/api/reports/ai-images").then(res => res.text()).then(text => {
        this.content = text;
      });
    },
    generate() {
      this.generating = true;
      fetch("/api/openai/image").then(res => res.json()).then(json => {
        this.generating = false;
        this.image = json;
      });
    },
  },
  computed: {
    converted(): string {
      if (!this.content) {
        return "";
      }
      return marked(this.content);
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, DataType, MethodType, ComputedType, unknown>);
